import {
  AuthenticatedDataRequest,
  AuthenticatedDataRequestWithHeaders
} from '@eggplant/data-request'
import { TOGGLES } from '@eggplant/api-hosts'
import type {
  Error,
  TogglesResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: TogglesResponse) => ReactElement | boolean
  onSuccess?: (response: TogglesResponse) => void
  onError?: (error: Error) => void
  hasHeaders?: boolean
}

const GetTogglesRequest = ({
  children,
  onSuccess,
  onError,
  hasHeaders = false
}: Props) => {
  const url = `${TOGGLES}/toggles`

  const Request = hasHeaders
    ? AuthenticatedDataRequestWithHeaders
    : AuthenticatedDataRequest

  return (
    <Request
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetTogglesRequest
